export const getCurrencyForCountry = (country: string): string => {
    switch (country) {
        case 'SE':
            return 'SEK'
        default:
            return 'EUR'
    }
}
